// @ts-nocheck
import { initKeyboardFocus } from '@theme/utilities';

const checkSidebar = () => {
  const hasSubNav = document.querySelector('.sub-category-nav');
  const filterSummary = document.querySelector('.ss__filter-summary');

  if (hasSubNav && filterSummary) {
    filterSummary.classList.add('with-subnav');
  }
};

const observer = new MutationObserver(() => {
  checkSidebar();
  initSearchInputKeyboardFocus();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Update selected category nav spacing
checkSidebar();
document.addEventListener('ss:render', checkSidebar);

// Manage close button visibility in Searchspring autocomplete
document.addEventListener('DOMContentLoaded', () => {
  initAutocompleteClose('.ss_wrapper-autocomplete');
});

// SAIL CUSTOM - Keyboard-focus outline for ss__search-input (facet search inputs, rendered dynamically)
function initSearchInputKeyboardFocus() {
  document.querySelectorAll('.ss__search-input').forEach((wrapper) => {
    if (wrapper.dataset.keyboardFocusInit) return;
    wrapper.dataset.keyboardFocusInit = 'true';
    const input = wrapper.querySelector('.ss__search-input__input');
    if (!input) return;
    initKeyboardFocus(input, wrapper);
  });
}

document.addEventListener('ss:render', initSearchInputKeyboardFocus);
document.addEventListener('DOMContentLoaded', initSearchInputKeyboardFocus);

function initAutocompleteClose(selector) {
  const wrappers = document.querySelectorAll(selector);
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const input = wrapper.querySelector('input[type="search"]');
    const results = wrapper.querySelector('.ss_autocomplete-results');
    const closeBtn = wrapper.querySelector('.predictive-search__close-modal-button');

    if (!input || !results || !closeBtn) return;

    const findRealResults = () => !!wrapper.querySelector('.ss__product-card-custom');

    const updateCloseVisibility = () => {
      const hasValue = input.value.trim().length > 0;
      const hasResults = findRealResults();
      const show = hasValue && hasResults;

      closeBtn.style.visibility = show ? 'visible' : 'hidden';
      closeBtn.setAttribute('aria-hidden', show ? 'false' : 'true');
    };

    const closeAutocomplete = () => {
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      updateCloseVisibility();
    };

    input.addEventListener('input', () => {
      requestAnimationFrame(updateCloseVisibility);
    });

    document.addEventListener('ss:autocomplete-render', () => {
      requestAnimationFrame(updateCloseVisibility);
    });

    document.addEventListener('ss:render', updateCloseVisibility);

    const obs = new MutationObserver(() => {
      updateCloseVisibility();
    });

    obs.observe(wrapper, { childList: true, subtree: true });

    closeBtn.addEventListener('click', closeAutocomplete);

    // SAIL CUSTOM - Show focus outline on wrapper only when focused via keyboard (not click)
    initKeyboardFocus(input, wrapper);
  });
}
